import Vue from 'vue';
import InitalQuotationAmounts from '../../modules/quotation/domain/InitalQuotationAmounts';

export default {
  namespaced: true,

  state: {
    preinvoice: null,
  },

  getters: {
    getPreinvoice(state) {
      return state.preinvoice;
    },

    getInitialQuotationAmounts(state) {
      const initialQuotationAmounts = new InitalQuotationAmounts();

      if (state.preinvoice) {
        return initialQuotationAmounts.fromPreinvoice(state.preinvoice);
      }

      return initialQuotationAmounts;
    },
  },

  mutations: {
    SET_PREINVOICE(state, payload) {
      Vue.set(state, 'preinvoice', payload);
    },
  },
};
